import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import './App.css';
import WelcomePanel, { id as WelcomePanelId } from './WelcomePanel';
import WhoPanel, { id as WhoPanelId } from './WhoPanel';
import ProjectsPanel, { id as ProjectsPanelId } from './ProjectsPanel';
import WorksPanel, { id as WorksPanelId } from './WorksPanel';
import KnowledgePanel, { id as KnowledgePanelId } from './KnowledgePanel';
import FloatingNavPanel from './FloatingNavPanel';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { panelIndex: 0, width: window.innerWidth, };
  }

  getOffset(element){
    var bounding = element.getBoundingClientRect();
    return {
      top: bounding.top + document.body.scrollTop,
      left: bounding.left + document.body.scrollLeft
    };
  };

  handleScroll(){
    if (this.state.width <= 500) {
      return;
    }
    const windowHeight = window.innerHeight;
    const maxPanelIndex = 5;

    const offset = this.getOffset(ReactDOM.findDOMNode(this.whoPanel));
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop >= offset.top) {
      ReactDOM.findDOMNode(this.floatingNavPanel).classList.add("FloatingNavPanel");
    }else{
      ReactDOM.findDOMNode(this.floatingNavPanel).classList.remove("FloatingNavPanel");
    }
    let panelIndex = 0;
    if (windowsScrollTop > windowHeight/2) {
      panelIndex = Math.min(
        Math.floor((windowsScrollTop + windowHeight * 3/2) / windowHeight),
        maxPanelIndex
      );
    }
    this.setState({ panelIndex: panelIndex });
  };

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentDidMount() {
      window.addEventListener('scroll', this.handleScroll.bind(this));
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    window.removeEventListener('resize', this.handleWindowSizeChange);
  };

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { panelIndex, width } = this.state;
    const isMobile = width <= 500;
    const navigationPanel = isMobile ? undefined :
      (
        <FloatingNavPanel
          ref={(panel) => { this.floatingNavPanel = panel; }}
          navigationItems={
            [
              { name: 'Welcome', id: WelcomePanelId },
              { name: 'Who', id: WhoPanelId },
              { name: 'Projects', id: ProjectsPanelId },
              { name: 'Works', id: WorksPanelId },
              { name: 'Knowledge', id: KnowledgePanelId }
            ]
          }
          currentNavigationItemIndex={panelIndex}
        /> 
      );
  
    const appType = isMobile ? 'App MobileApp' : 'App';
    return (
      <div className={appType}>
        {navigationPanel}
        <WelcomePanel isMobile={isMobile} />
        <WhoPanel ref={(panel) => { this.whoPanel = panel; }} isMobile={isMobile} />
        <ProjectsPanel isMobile={isMobile} />
        <WorksPanel isMobile={isMobile} />
        <KnowledgePanel isMobile={isMobile} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js